<template>
  <section id="top" class="mt-12 container-margin">
    <v-container fluid class="text-center">
      <div v-if="isMobile" class="mt-12">
        <span class="font-weight-black black--text custom-font headline">
          DISASTER
        </span>
        <span class="font-weight-black red--text custom-font headline">
          RELIEF
        </span>
      </div>
      <!-- Hero Image with Overlay Text -->
      <v-img
        src="@/assets/ems_images/disaster_page.webp"
        height="300"
        dark
        class="mt-10"
        gradient="to bottom, rgba(0,0,0, .1), rgba(0,0,0, .7)"
      >
      </v-img>
    </v-container>
    <v-container class="text-center">
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black black--text custom-font"
      >
        OUR
      </span>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black red--text custom-font"
      >
        SERVICES
      </span>
      <v-responsive
        class="my-10 mx-auto title font-weight-light mb-8"
        max-width="720"
        >Available 24/7, our Disaster Relief team is ready to tackle urgent
        mould and asbestos issues, conduct advanced air testing, and manage
        flood crises. We excel in fire damage repair, employing advanced air
        scrubbing and providing emergency board-ups. Our thorough approach
        extends to trauma scene cleanups and a comprehensive equipment rental
        service for effective disaster response.
      </v-responsive>
      <!-- Services List -->
      <v-row class="mt-5">
        <v-col
          v-for="({ icon, title, text }, i) in services"
          :key="i"
          cols="12"
          md="4"
        >
          <!-- Updated Card Styling -->
          <v-card
            height="400"
            class="py-12 px-4"
            color="grey lighten-3"
            flat
            elevation="2"
          >
            <v-theme-provider dark>
              <div class="my-1">
                <v-avatar color="black" size="60">
                  <v-icon color="red" large v-text="icon"></v-icon>
                </v-avatar>
              </div>
            </v-theme-provider>
            <v-card-title
              class="justify-center font-weight-bold text-uppercase black--text no-wrap-class subtitle-1"
              v-text="title"
            ></v-card-title>

            <v-card-text class="body-1 black--text" v-html="text"></v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-divider class="mb-1 mt-10"></v-divider>
      <v-divider class="mb-10"></v-divider>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black black--text custom-font"
      >
        OUR
      </span>
      <span
        :class="[$vuetify.breakpoint.smAndDown ? 'headline' : 'display-2']"
        class="font-weight-black red--text custom-font"
      >
        WORK
      </span>

      <v-carousel hide-delimiters class="mt-10">
        <v-carousel-item v-for="(item, i) in work" :key="i">
          <v-row class="fill-height">
            <v-col
              cols="12"
              class="d-flex justify-center align-center position-relative"
            >
              <v-img
                :src="item.src"
                cover
                :class="{ 'my-image': !isMobile, 'my-image-mobile': isMobile }"
              ></v-img>
              <v-container
                class="position-absolute white--text text-center overlay-text"
                :class="{ 'overlay-text-mobile': isMobile }"
                style="
                  bottom: 0;
                  left: 0;
                  right: 0;
                  background-color: rgba(0, 0, 0, 0.5);
                "
              >
                <span
                  :class="{ headline: !isMobile, 'headline-mobile': isMobile }"
                  >{{ item.title }}</span
                >
                <p
                  :class="{
                    description: !isMobile,
                    'description-mobile': isMobile,
                  }"
                >
                  {{ item.description }}
                </p>
              </v-container>
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-container>
  </section>
</template>




<script>
import { mapGetters } from "vuex";
export default {
  name: "BuildingMaintenanceServicesPage",
  components: {},
  computed: {
    ...mapGetters(["isMobile"]),
  },
  data() {
    return {
      services: [
        {
          icon: "mdi-hazard-lights",
          title: "Asbestos Removal & Mould Remediation",
          text: "Specialized procedures for addressing mould and asbestos to ensure safe and thorough removal. Our team is equipped to handle the complexities of these hazardous materials.",
        },
        {
          icon: "mdi-air-filter",
          title: "Air Testing with Advanced Technology",
          text: "Utilizing state-of-the-art technology to conduct air tests, ensuring the building's air quality meets safe parameters. We test for indoor contaminants, including lead and various VOCs, for a safe environment in homes and workspaces.",
        },
        {
          icon: "mdi-water-pump",
          title: "Flood Response (Flood Restoration)",
          text: "We specialize in flood restoration, utilizing advanced techniques to extract water and minimize structural damage. By promptly setting up blowers and dehumidifiers, we prevent mold accumulation and ensure a safe living environment.",
        },
        {
          icon: "mdi-fire-truck",
          title: "Fire Damage Restoration (Fire Restoration)",
          text: "Employing HEPA filtered air scrubbers to purify the air and comprehensive surface remediation to eliminate soot residue. We meticulously remediate all surfaces affected by smoke and soot, restoring them to their pre-fire condition.",
        },
        {
          icon: "mdi-shield-home-outline",
          title: "Emergency Board-Ups",
          text: "Rapid response to secure sites post-break-ins or vehicle impacts using plywood and boards for the owners' peace of mind. In the event of a break-in or vehicle impact, we provide emergency board-up services to secure the affected sites.",
        },
        {
          icon: "mdi-biohazard",
          title: "Trauma Scene Cleanup",
          text: "Professional handling of bloodborne pathogens and thorough decontamination of affected areas in trauma situations. Werek Construction handles the cleanup and decontamination, providing a safe and hygienic environment.",
        },
        {
          icon: "mdi-truck-fast-outline",
          title: "Equipment Rentals",
          text: "Large inventory available for any scale of disaster, including blower, air scrubber, and dehumidifier rentals.",
        },
      ],
      work: [
        {
          src: require("@/assets/ems_images/placeholder.png"),
          title: "Sherway Gardens", // Title in Capital Case
          description:
            "Fire that occurred on the 17th floor of the building, causing water to flow down to the ground level. As a result, the elevators were disabled due to the water damage. The crew faced the challenge of carrying all the necessary equipment, including over 150 air movers (devices used to circulate air) and over 50 dehumidifiers, up the stairs to mitigate the water damage and restore the affected areas.", // Description in Sentence Case
        },
        {
          src: require("@/assets/ems_images/placeholder.png"),
          title: "Ashglen Way in Unionville", // Title in Capital Case
          description:
            "Water main break on Ashglen Way in Unionville. In order to fix the issue, excavation work was necessary. The damaged section of the water main was excavated and replaced, and then the area was backfilled.", // Description in Sentence Case
        },
        {
          src: require("@/assets/ems_images/placeholder.png"),
          title: "Metroplace Condos", // Title in Capital Case
          description:
            "Leak in the boiler system, which resulted in water damage to 23 separate units. The water damage extended across 13 floors of the building. The necessary measures were taken to repair the boiler system, mitigate the water damage, and restore the affected units and floors to their original condition.", // Description in Sentence Case
        },
        // ... any additional images with their respective titles and descriptions
      ],
    };
  },
};
</script>

<style scoped>
.my-image {
  max-width: 100%;
  max-height: 500px;
}
.my-image-mobile {
  max-height: 300px; /* Adjust for mobile */
}
.overlay-text {
  padding: 16px;
}
.overlay-text-mobile {
  padding: 18px; /* Smaller padding for mobile */
}
.headline {
  font-size: 1.5rem;
}
.headline-mobile {
  font-size: 1rem; /* Smaller font size for mobile */
}
.description {
  font-size: 1rem;
}
.description-mobile {
  font-size: 0.8rem; /* Smaller description font for mobile */
}
.no-wrap-class {
  word-break: keep-all;
  hyphens: manual;
}
.container-margin {
  margin-bottom: 200px; /* Offset by the height of v-app-bar */
}

.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
</style>
